import { render } from "./SmViewComponent.vue?vue&type=template&id=6b919582"
import script from "./SmViewComponent.vue?vue&type=script&lang=js"
export * from "./SmViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/SmViewComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b919582"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b919582', __exports__)) {
    api.reload('6b919582', __exports__)
  }
  
  module.hot.accept("./SmViewComponent.vue?vue&type=template&id=6b919582", () => {
    api.rerender('6b919582', render)
  })

}


export default __exports__